export const fr = {
    REQUIRED_ACTION_KeepCapturing: 'Continuez à capturer',
    REQUIRED_ACTION_PauseCapturing: 'Pause de la capture',
    REQUIRED_ACTION_Close: 'Fermer',
    REQUIRED_ACTION_Error: 'Erreur',
    REQUIRED_ACTION_AGREE: "D'accord",
    REQUIRED_ACTION_DISAGREE: "Pas d'accord",
    LIVENESS_ACTION_Smile: 'Sourire',
    LIVENESS_ACTION_Frown: 'Froncer les sourcils',
    'LIVENESS_ACTION_Tilt Left': 'Regarde à gauche',
    'LIVENESS_ACTION_Tilt Right': 'Regarde à droite.',
    'LIVENESS_ACTION_Tilt Up': 'Regarde en haut.',
    'LIVENESS_ACTION_Tilt Down': 'Regarde en bas.',
    'LIVENESS_ACTION_Look Straight': 'Regarde droit devant.',
    'LIVENESS_ACTION_No Action': 'Aucune action',
    LIVENESS_ACTION_PROCESSING_LIVENESS: 'Traitement du caractère vivant',
    'LIVENESS_RESULT_Thank you!.Failed': 'Échoué',
    'LIVENESS_RESULT_Thank you!.Passed': 'Passé',
    'LIVENESS_RESULT_Thank you!.ActionTimedOut': 'Action expirée',
    'LIVENESS_RESULT_Thank you!.Interrupted': 'Interrompu',
    'LIVENESS_RESULT_Thank you!.Undefined': 'Indéfini',
    LIVENESS_ACTION_LOOK_STRAIGHT_TITLE: 'Regardez droit devant vous',
    LIVENESS_ACTION_LOOK_STRAIGHT_TEXT:
        "Gardez les yeux sur l'écran à tout moment",
    LIVENESS_ACTION_LOOK_LEFT_TITLE:
        'Tournez légèrement la tête vers la gauche',
    LIVENESS_ACTION_LOOK_LEFT_TEXT: "Gardez les yeux sur l'écran à tout moment",
    LIVENESS_ACTION_LOOK_RIGHT_TITLE:
        'Tournez légèrement la tête vers la droite',
    LIVENESS_ACTION_LOOK_RIGHT_TEXT:
        "Gardez les yeux sur l'écran à tout moment",
    LIVENESS_ACTION_LOOK_UP_TITLE: 'Tournez légèrement la tête vers le haut',
    LIVENESS_ACTION_LOOK_UP_TEXT: "Gardez les yeux sur l'écran à tout moment",
    LIVENESS_ACTION_LOOK_DOWN_TITLE: 'Tournez légèrement la tête vers le bas',
    LIVENESS_ACTION_LOOK_DOWN_TEXT: "Gardez les yeux sur l'écran à tout moment",
    LIVENESS_ACTION_SMILE_TITLE: 'Sourire',
    LIVENESS_ACTION_SMILE_TEXT: "Gardez les yeux sur l'écran à tout moment",
    LIVENESS_ACTION_FROWN_TITLE: 'Froisser',
    LIVENESS_ACTION_FROWN_TEXT: "Gardez les yeux sur l'écran à tout moment",
    PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE:
        'Euh Oh... Vous êtes trop près.',
    PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE:
        'Euh Oh... Vous êtes trop près.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE:
        "Nous ne parvenons pas à détecter un visage dans l'image. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE:
        'Euh Oh... Vous êtes trop loin.',
    PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE:
        "Euh Oh... Une erreur s'est produite.",
    ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES:
        "Nous ne parvenons pas à détecter un visage sur l'image. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE:
        'Oh oh... Nous ne parvenons pas à détecter un visage.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_UNKNOWN:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_INTERNAL:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_None_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_None:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_FailedExpressions:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_NULLPTR:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR:
        "Une erreur s'est produite. Veuillez réessayer.",
    PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE:
        "Oh oh... Quelque chose s'est mal passé.",
    PASSIVE_LIVENESS_ERROR_INVALID_META:
        "Une erreur s'est produite. Veuillez réessayer.",
    INITIALIZING_TITLE: 'Initialisation',
    INITIALIZING_DESCRIPTION:
        'Vérification des capacités matérielles, veuillez patienter...',
    JOURNEY_STATE_STARTED: 'Commencé',
    JOURNEY_STATE_INPROGRESS: 'En cours',
    JOURNEY_STATE_ENDED: 'Terminé',
    INFO_JOURNEY_STATE: 'État',
    INFO_JOURNEY_ACTION: 'Action',
    INFO_JOURNEY_ACTION_ATTEMPT: "Tentative d'action",
    INFO_JOURNEY_ID: 'Identifiant du voyage',
    INFO_JOURNEY_RESULT: 'Résultat',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE: 'Message de résultat',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE:
        "L'identifiant que vous nous avez fourni n'est pas à jour – essayez autre chose",
    INFO_JOURNEY_REFERENCE: 'Référence',
    FLOW_STATE_NONE: 'Aucun',
    'FLOW_STATE_IDENTITY:FRONT': 'Côté avant',
    'FLOW_STATE_IDENTITY:BACK': 'Côté arrière',
    FLOW_STATE_ADDRESS: 'Adresse',
    FLOW_STATE_SELFIE: 'Selfie',
    FLOW_STATE_LIVENESS: 'Vivacité',
    FLOW_STATE_COVID: 'Covid',
    PROVIDER_TITLE_CAMERA: 'Appareil photo',
    PROVIDER_TITLE_CROPPER: 'Moissonneuse',
    PROVIDER_TITLE_FILESYSTEM_ID:
        "Téléchargez une photo de votre pièce d'identité",
    PROVIDER_TITLE_FILESYSTEM_FACEMATCH: 'Téléchargez une photo de vous-même',
    PROVIDER_TITLE_FILESYSTEM_ADDRESS:
        'Téléchargez une photo de votre justificatif de domicile',
    PROVIDER_TITLE_FILESYSTEM_COVID:
        'Téléchargez une photo de votre document Covid',
    PROVIDER_TITLE_GATEWAY: 'Passerelle',
    PROVIDER_TITLE_LIVENESS: 'Vivacité',
    PROVIDER_TITLE_LOGIN: 'Connexion',
    PROVIDER_TITLE_RESULTS: 'Résultats',
    PROVIDER_TITLE_SCANNER: "Scannez votre pièce d'identité",
    PROVIDER_TITLE_VIEW_ID: "Vérifiez l'aperçu de votre pièce d'identité",
    PROVIDER_TITLE_VIEW_FACEMATCH: "Vérifiez l'aperçu de votre selfie",
    PROVIDER_TITLE_VIEW_ADDRESS:
        "Vérifiez l'aperçu de votre justificatif de domicile",
    ROVIDER_TITLE_VIEW_COVID: "Vérifiez l'aperçu de votre Covid",
    PROVIDER_SUBTITLE_FILESYSTEM_ID:
        "Veuillez télécharger une photo de votre pièce d'identité qui est claire, nette, non couverte et directement de face.",
    PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH:
        'Veuillez télécharger une photo de votre document qui est claire, nette, non couverte et directement de face.',
    PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS:
        'Veuillez télécharger une photo de votre document qui est claire, nette, non couverte et directement de face.',
    PROVIDER_SUBTITLE_FILESYSTEM_COVID:
        "Placez la page photo de votre pièce d'identité face vers le bas sur le scanner.",
    PROVIDER_SUBTITLE_SCANNER_ID:
        "Veuillez vérifier que l'aperçu de votre document est clair, net, non couvert et directement de face.",
    PROVIDER_SUBTITLE_VIEW_ID:
        "Veuillez vérifier que l'aperçu de votre selfie est clair, net, non couvert et directement de face.",
    PROVIDER_SUBTITLE_VIEW_FACEMATCH:
        "Veuillez vérifier que l'aperçu de votre document est clair, net, non couvert et directement de face.",
    PROVIDER_SUBTITLE_VIEW_ADDRESS:
        "Veuillez vérifier que l'aperçu de votre document est clair, net, non couvert et directement de face.",
    PROVIDER_SUBTITLE_VIEW_COVID:
        "Veuillez vérifier que l'aperçu de votre document est clair, net, non couvert et directement de face.",
    PROVIDER_TITLE_SMART_CAPTURE: 'Capture intelligente',
    PROVIDER_TITLE_JOURNEY_SELECT: 'Voyage Sélectionné',
    PROVIDER_TITLE_TERMS_AND_CONDITIONS: 'Conditions générales',
    PROVIDER_TITLE_USER_INPUT: 'Veuillez remplir le formulaire suivant',
    FILESYSTEM_SUPPORTED_TYPES_FIRST: 'Formats acceptés :',
    FILESYSTEM_SUPPORTED_TYPES_LIST: 'JPG, PNG',
    FILESYSTEM_SUPPORTED_TYPES_START_SELFIE: 'Formats acceptés : JPG, PNG',
    FILESYSTEM_MAX_FILE_SIZE:
        'Taille du fichier : nous acceptons tout fichier de taille inférieure à',
    FILESYSTEM_MAX_FILE_SIZE_NUMBER: '7,5 Mo',
    FILESYSTEM_CHECK_FILE_TOO_BIG:
        'Votre fichier est trop volumineux. Veuillez télécharger un fichier de taille inférieure à 7,5 Mo.',
    FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT:
        "Votre fichier n'a pas le bon format. Veuillez télécharger l'un des formats acceptés.",
    FILESYSTEM_IDENTITY_DOCUMENT: "Pièce d'identité",
    FILESYSTEM_FACEMATCH: 'Face Match',
    FILESYSTEM_ADDRESS: "Preuve d'adresse",
    FILESYSTEM_COVID: 'Covid',
    FILESYSTEM_DRAG_DROP: 'Glisser-déposer',
    FILESYSTEM_OR: 'ou',
    FILESYSTEM_CHOOSE: 'Choisir un fichier',
    FILESYSTEM_UPLOADING: 'Téléchargement...',
    TRIPLESCAN_GUIDANCE_TRYAGAIN: 'Réessayer',
    FAILURE_REASON_REFER: "Votre pièce d'identité n'a pas été validée.",
    FAILURE_REASON_EXPIRED: "Votre pièce d'identité est expirée.",
    FAILURE_REASON_NOT_ACCEPTED:
        "Votre pièce d'identité n'est pas un type de document accepté.",
    FAILURE_REASON_NOT_SUPPORTED:
        "Votre pièce d'identité n'a pas pu être classée ou n'est pas prise en charge.",
    PLEASE_TRY_AGAIN_REFER: 'Veuillez réessayer.',
    PLEASE_TRY_AGAIN_EXPIRED: 'Veuillez réessayer avec un document valide.',
    PLEASE_TRY_AGAIN_NOT_ACCEPTED: 'Veuillez réessayer avec un autre document.',
    PLEASE_TRY_AGAIN_NOT_SUPPORTED: 'Veuillez réessayer.',
    BLUR_CHECK_REASON: "Flou - le document n'est pas clair ;",
    GLARE_CHECK_REASON:
        "Éblouissement - le document est illisible en raison d'une source de lumière vive ;",
    RESOLUTION_CHECK_REASON:
        'Basse résolution - le document ne remplit pas correctement le cadre ;',
    EDGES_CHECK_REASON:
        "Bords manquants - le document n'est pas correctement positionné dans le cadre ;",
    VALIDATION_FAILED: 'Validation échouée',
    VALIDATION_FAILED_REASON_DOC_UNKNOWN: '- document inconnu.',
    VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED: '- document non accepté.',
    VALIDATION_FAILED_REASON_DOC_EXPIRED: '- document expiré.',
    PREVIEW_INFO_TITLE_ID: 'Exemples de bonnes et de mauvaises photos',
    PREVIEW_INFO_GOOD: 'Bonnes',
    PREVIEW_INFO_BAD: 'Mauvaises',
    PREVIEW_INFO_GOOD_EXAMPLE_ID:
        'La photo est claire, nette et directement de face.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID:
        'La photo doit montrer les quatre coins.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ID:
        'Le document ne doit pas être recouvert.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID: 'La photo ne doit pas être floue.',
    PREVIEW_INFO_TITLE_FACEMATCH: 'Conseils pour un selfie de bonne qualité',
    PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH:
        'Le selfie est clair, net et directement de face.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH:
        'Le selfie doit montrer le visage en entier.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH:
        'Le visage ne doit pas être couvert.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH: 'Le selfie ne doit pas être flou.',
    PREVIEW_INFO_TITLE_ADDRESS: 'Conseils pour une photo de bonne qualité',
    PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS:
        'La photo est claire, nette et directement de face.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS:
        'La photo doit montrer les quatre coins.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS:
        'Le document ne doit pas être couvert.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS: 'La photo ne doit pas être floue.',
    PREVIEW_INFO_TITLE_COVID: 'Conseils pour une photo de bonne qualité',
    PREVIEW_INFO_GOOD_EXAMPLE_COVID:
        'La photo est claire, nette et directement de face.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID:
        'La photo doit montrer les quatre coins.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID:
        'Le document ne doit pas être recouvert.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID: 'La photo ne doit pas être floue.',
    ATTEMPTS_REMAINING: 'Nombre de tentatives restantes :',
    CAMERA_CAPTURE: "Allumer l'appareil photo",
    CAMERA_CAPTURE_START_BUTTON: 'Démarrer la capture automatique',
    CAMERA_CAPTURE_CAPTION:
        'Cliquez sur Démarrer la capture automatique pour commencer',
    CAMERA_PREVIEW_START:
        'Allumez votre appareil photo pour démarrer la capture automatique',
    CAMERA_CONDITION_BLUR: 'Flou détecté',
    CAMERA_CONDITION_CAPTURING: 'Capture en cours',
    CAMERA_CONDITION_UPLOADING: 'Téléchargement... Veuillez patienter',
    CAMERA_CONDITION_ALIGNMENT: "Le document n'est pas dans le cadre",
    CAMERA_CONDITION_GLARE: 'Éblouissement détecté',
    VERIFYING_TITLE: 'Vérification ...',
    PREPARING_PREVIEW_TITLE: "Préparation de l'aperçu ...",
    CAMERA_CONDITION_LOW_RESOLUTION: 'Document trop loin',
    CAMERA_LOADING: "Ouverture de l'appareil photo...",
    CAMERA_SMARTCAPTURE_ON: 'CAPTURE AUTOMATIQUE - ACTIVÉE',
    CAMERA_SMARTCAPTURE_OFF: 'CAPTURE AUTOMATIQUE - DÉSACTIVÉE',
    CAMERA_CAPTURE_FRONT:
        "Positionnez le côté photo de votre document d'identité dans le cadre ci-dessous.",
    CAMERA_MANUAL_CAPTURE_FRONT:
        "Positionnez votre pièce d'identité dans le cadre et cliquez sur le bouton ci-dessous",
    CAMERA_CAPTURE_BACK:
        "Positionnez le VERSO de votre pièce d'identité dans le cadre",
    CAMERA_CAPTURE_SELFIE_CAPTION:
        "Positionnez votre visage dans l'ovale, regardez directement dans l'appareil photo et cliquez sur le bouton ci-dessous pour prendre un selfie.",
    CAMERA_CAPTURE_ADDRESS_CAPTION:
        'Positionnez votre justificatif de domicile dans le cadre et cliquez sur le bouton ci-dessous pour prendre une photo.',
    CAMERA_CAPTURE_COVID_CAPTION:
        'Positionnez votre document Covid dans le cadre et cliquez sur le bouton ci-dessous pour prendre une photo.',
    CAMERA_PREVENT_GLARE_HINT:
        'Éloignez le document des sources de lumière directe.',
    CAMERA_PREVENT_BLUR_HINT: "Maintenez le document ou l'appareil fermement.",
    CAMERA_PREVENT_LOW_RES_HINT:
        'Ajustez complètement le document dans le cadre.',
    CROPPER_RETRY: 'Réessayer',
    CROPPER_UPLOAD: 'Télécharger',
    CROPPER_UPLOADING: 'Téléchargement en cours...',
    FILESYSTEM_SELECT: 'Sélectionnez',
    FILESYSTEM_DROP_IMAGE: "ou déposez l'image",
    GATEWAY_CAMERA: 'Appareil photo activé',
    GATEWAY_CANCEL: 'Annuler Journey',
    LIVENESS_START: 'Démarrer Liveness',
    PASSIVE_LIVENESS_START: 'Prendre une photo',
    LOGIN_USERNAME: "Nom d'utilisateur",
    LOGIN_PASSWORD: 'Mot de passe',
    LOGIN_SUBMIT: 'Soumettre',
    RESULTS_DOCUMENTS: 'Documents',
    RESULTS_DOCUMENTS_NONE: 'Aucun résultat trouvé',
    RESULTS_DOCUMENT_TYPE: 'Type de document',
    RESULTS_DOCUMENT_RESULT: 'Résultat du document',
    RESULTS_EXTRACTED_FIELDS_NONE: 'Détails du résultat',
    RESULTS_DETAILS_NONE: 'Aucun résultat trouvé',
    RESULTS_NEW_JOURNEY: 'Commencer un nouveau voyage',
    RESULTS_NO_INFORMATION: "Il n'y a aucune information pour ce voyage",
    RESULTS_LOGOUT: 'Déconnexion',
    RESULTS_HIGH_LEVEL_Aborted: 'Avorté',
    RESULTS_HIGH_LEVEL_TCCDISAGREE: 'Conditions générales avortées',
    RESULTS_HIGH_LEVEL_Expired: 'Expiré',
    RESULTS_HIGH_LEVEL_NotAccepted: 'Non accepté',
    RESULTS_HIGH_LEVEL_NotSupported: 'Non pris en charge',
    RESULTS_HIGH_LEVEL_Notsupported: 'Non pris en charge',
    RESULTS_HIGH_LEVEL_Passed: 'Passé',
    RESULTS_HIGH_LEVEL_Refer: 'Référence',
    RESULTS_HIGH_LEVEL_Undefined: 'Indéfini',
    RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT:
        'Résultat de vivacité accumulée',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK:
        'Vérification du type de document côté recto.',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK:
        'Vérification du verso du document',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY:
        'Politique de blocage des documents',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY: "Date d'expiration du document",
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT: 'Support de document',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION: 'Validation de document',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY:
        'Politique de preuve documentaire',
    RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION: 'Validation de Facematch',
    RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE: 'Règle des mineurs',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED:
        'Le succès est au rendez-vous',
    RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK:
        'Vérification de la compatibilité du passeport Covid',
    RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK: 'Contrôle des données',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED: 'Échoué',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED: 'Pas nécessaire.',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED: 'Passé',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED: 'traduction en français',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED: 'Indéterminé',
    ADDITIONAL_CHECKS_DETAILS: 'Contrôles supplémentaires',
    ADDITIONAL_CHECKS_DETAILS_NONE: 'Aucun trouvé',
    ADDITIONAL_CHECKS_DETAIL_DATACHECKS: 'Vérification des données',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK: 'Contrôles de rétrospection',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA: 'SANS OBJET',
    GBG_SCORES: 'Scores GBG',
    GBG_TRUST_SCORE: 'Score GBG Trust',
    GBG_SCORE: 'Score GBG',
    PREVIEW_TITLE: 'La photo de votre document est-elle nette ?',
    VIEW_RETRY: 'REPRENDRE LA PHOTO',
    VIEW_RETRY_DESKTOP: 'Photo du changement',
    VIEW_CROP: 'Récolte',
    VIEW_CROPPING: 'Rognage...',
    VIEW_UPLOAD: 'Télécharger',
    VIEW_UPLOAD_PREVIEW: 'OUI, CONTINUER',
    VIEW_UPLOADING: 'Téléchargement en cours...',
    SMART_CAPTURE_INITIALIZING: 'Commencer',
    SMART_CAPTURE_START:
        'Initialisation de la capture intelligente, veuillez patienter...',
    SCANNER_DESC_AVAILABLE:
        'Le scanner est disponible. Placez votre document dans le scanner.',
    SCANNER_DESC_PROCESSING:
        "L'image est en cours de traitement par le serveur.",
    SCANNER_DESC_SCANNING:
        "L'image est en train d'être scannée par l'appareil.",
    SCANNER_DESC_DISCONNECTED: 'Le scanner est déconnecté du réseau.',
    SCANNER_DESC_NOT_CONNECTED: "Le scanner n'est pas connecté.",
    SCANNER_DESC_OFFLINE: 'Le scanner est hors ligne.',
    SCANNER_DESC_BUSY:
        'Le scanner est utilisé par un autre utilisateur dans votre réseau local.',
    SCANNER_DESC_WAITING: "En attente de l'établissement de la connexion.",
    SCANNER_DESC_LOADING: 'Veuillez patienter...',
    SCANNER_TITLE_SCANNING: 'BALAYAGE',
    SCANNER_TITLE_DISCONNECTED: 'DÉCONNECTÉ',
    SCANNER_TITLE_NOT_CONNECTED: 'PAS CONNECTÉ',
    SCANNER_TITLE_OFFLINE: 'Scanner hors ligne',
    SCANNER_TITLE_BUSY: 'Scanner occupé',
    SCANNER_TITLE_WAITING: 'ATTENTE',
    SCANNER_ACTION_REGISTER: 'Enregistrer',
    SCANNER_ACTION_RELEASE: 'Libération',
    CANCEL_JOURNEY: 'Annuler',
    MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE: 'Téléchargez une photo à la place',
    MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE: 'Prendre une photo à la place',
    JOURNEY_SELECT_CONTINUE: 'Continuer',
    HELP_MODAL_AUTOCAPTURE_TITLE:
        "Comment prendre une photo de votre document d'identité",
    HELP_MODAL_AUTOCAPTURE_SUBTITLE:
        "Lorsque la fonction de capture automatique est activée, l'écran de capture prend automatiquement une photo de votre document lorsqu'il reconnaît qu'il est d'une qualité suffisante.",
    HELP_MODAL_AUTOCAPTURE_TIPS:
        'Conseils pour prendre une photo de bonne qualité',
    HELP_MODAL_AUTOCAPTURE_GLARE_TITLE: 'Évitez les reflets',
    HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE:
        'Éloignez le document des sources de lumière directe.',
    HELP_MODAL_AUTOCAPTURE_FAR_TITLE: 'Document trop éloigné',
    AUTOCAPTURE_FAR_SUBTITLE: 'Placez le document entièrement dans le cadre.',
    AUTOCAPTURE_BLUR_TITLE: 'Éviter le flou',
    HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE:
        "Tenez le document ou l'appareil de manière stable.",
    HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE:
        'Toujours en difficulté ? Prenez une photo avec la capture manuelle',
    HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE: 'Capture manuelle',
    HELP_MODAL_SELFIE_TITLE: 'Comment prendre un selfie',
    HELP_MODAL_SELFIE_SUBTITLE:
        "Regardez directement dans l'appareil photo et cliquez sur le bouton de capture manuelle.",
    HELP_MODAL_POA_TITLE:
        'Comment prendre une photo de votre justificatif de domicile ?',
    HELP_MODAL_POA_SUBTITLE:
        'Placez votre document dans le cadre et cliquez sur le bouton de capture pour prendre une photo de votre document.',
    HELP_MODAL_POA_TIPS: 'Conseils pour prendre une photo de bonne qualité',
    HELP_MODAL_POA_GLARE_TITLE: 'Évitez les reflets',
    HELP_MODAL_POA_GLARE_SUBTITLE:
        'Éloignez le document des sources de lumière directe.',
    HELP_MODAL_POA_FAR_TITLE: 'Document trop éloigné',
    HELP_MODAL_POA_FAR_SUBTITLE:
        'Placez le document entièrement dans le cadre.',
    HELP_MODAL_POA_BLUR_TITLE: 'Éviter le flou',
    HELP_MODAL_POA_BLUR_SUBTITLE: "Maintenez le document ou l'appareil stable.",
    HELP_MODAL_POA_MANUAL_CAPTURE:
        'Vous avez encore des difficultés ? Activez la capture manuelle',
    HELP_MODAL_POA_TURN_MANUAL_CAPTURE: 'Capture manuelle',
    HELP_MODAL_COVID_TITLE:
        'Comment prendre une photo de votre document Covid ?',
    HELP_MODAL_COVID_SUBTITLE:
        'Positionnez votre document dans le cadre et cliquez sur le bouton de capture pour prendre une photo de votre document.',
    HELP_MODAL_COVID_TIPS: 'Conseils pour prendre une photo de bonne qualité',
    HELP_MODAL_COVID_GLARE_TITLE: 'Évitez les reflets',
    HELP_MODAL_COVID_GLARE_SUBTITLE:
        'Éloignez le document des sources de lumière directe.',
    HELP_MODAL_COVID_FAR_TITLE: 'Document trop éloigné',
    HELP_MODAL_COVID_FAR_SUBTITLE:
        'Placez le document entièrement dans le cadre.',
    HELP_MODAL_COVID_BLUR_TITLE: 'Prévenir le flou',
    HELP_MODAL_COVID_BLUR_SUBTITLE:
        "Maintenez le document ou l'appareil stable.",
    HELP_MODAL_COVID_MANUAL_CAPTURE:
        'Vous avez toujours du mal ? Activez la capture manuelle',
    HELP_MODAL_COVID_TURN_MANUAL_CAPTURE: 'Capture manuelle',
    HELP_MODAL_NEED_HELP: 'Aide et options',
    EXCEPTION: "Une exception inattendue s'est produite",
    EXCEPTION_AUTHORIZATION: 'Non autorisé',
    EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED:
        "Votre compte n'est pas autorisé à accéder à cette ressource",
    EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID:
        "La combinaison du nom d'utilisateur et du mot de passe n'est pas valide",
    EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED:
        "Vous devez activer l'authentification pour utiliser cette fonctionnalité",
    EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED:
        "Vous n'êtes pas autorisé pour ce processus",
    EXCEPTION_BAD_REQUEST: "Mauvaise demande avec le code d'état 400",
    EXCEPTION_BAD_REQUEST_INVALID_IMAGE: "L'image n'est pas valide",
    EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE: 'Le voyage attend une réponse',
    EXCEPTION_FLOW_STATE_JOURNEY_ENDED:
        "Impossible d'envoyer des demandes. Le voyage est terminé",
    EXCEPTION_FLOW_STATE_MISSING: "L'état du flux n'a pas été trouvé",
    EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION:
        'Le rappel doit être une fonction valide.',
    EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING:
        "Le nom de l'événement doit être une valeur de chaîne.",
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER:
        'La priorité doit être un nombre.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER:
        'La priorité doit être un nombre positif.',
    EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR:
        'Le conteneur doit être soit un élément, soit un sélecteur.',
    EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID: "La valeur n'est pas valide.",
    EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED: 'La valeur a été endommagée.',
    EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING:
        'La configuration devrait inclure un paramètre backendUrl.',
    EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING:
        'Les paramètres fournis doivent contenir des coordonnées.',
    EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING:
        'Les paramètres fournis doivent contenir des images.',
    EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING:
        'Les paramètres fournis doivent contenir le mot de passe.',
    EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING:
        "Les paramètres fournis doivent contenir le nom d'utilisateur.",
    EXCEPTION_MISSING_REQUIRED_FIELD_MISSING:
        'Veuillez remplir tous les champs obligatoires',
    EXCEPTION_POSTCODE_FORMAT_ERROR:
        "Le format du code postal n'est pas valide minLength:5 / maxLength:8",
    EXCEPTION_HOUSENUMBER_FORMAT_ERROR:
        "Le format du nom de la maison/numéro n'est pas valide minLength:1 / maxLength:20",
    EXCEPTION_STREETNAME_FORMAT_ERROR:
        "Le nom de la rue n'est pas valide minLongueur:1 / maxLongueur:30",
    EXCEPTION_TOWN_FORMAT_ERROR:
        "Le format de la ville n'est pas valide minLength:1 / maxLength:20",
    EXCEPTION_JOURNEY_DEFINITIONS_MISSING:
        "Aucune définition de trajet n'est disponible pour ce canal",
    EXCEPTION_NETWORK:
        "Une exception réseau s'est produite, veuillez vérifier votre connexion et réessayer.",
    EXCEPTION_PLATFORM_BROWSER_ONLY:
        'Cette fonctionnalité ne peut être utilisée que dans un navigateur',
    EXCEPTION_PLATFORM_UNSUPPORTED:
        'Votre environnement ne prend pas en charge cette fonctionnalité',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED:
        "Les autorisations pour la caméra n'ont pas été accordées, veuillez vérifier les paramètres de votre navigateur.",
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE: '',
    EXCEPTION_PLATFORM_CAMERA_NOT_READABLE:
        "Il n'a pas été possible d'accéder à la caméra. Veuillez fermer toutes les autres applications et réessayer.",
    EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE:
        "Aucune caméra appropriée n'a été trouvée sur votre appareil",
    EXCEPTION_SERVER: "La demande a échoué avec le code d'état 500",
    EXCEPTION_SERVER_UNREACHABLE: 'Échec de la demande, serveur inaccessible',
    EXCEPTION_SERVER_DATA_NOT_PERSISTED:
        "Une erreur s'est produite au cours du processus. Il se peut que vos données ne soient pas conservées.",
    EXCEPTION_SERVER_RESULT_NOT_PASSING: 'Le résultat actuel ne passe pas',
    EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE:
        "Le contexte Canvas n'est pas disponible",
    EXCEPTION_TEMPLATE_CONTAINER_MISSING: "Le conteneur n'est pas présent",
    EXCEPTION_TEMPLATE_ELEMENTS_MISSING: 'Éléments requis manquants',
    EXCEPTION_TEMPLATE_MISSING: 'Modèle non trouvé',
    EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING:
        "Impossible de trouver l'élément source",
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE:
        "Impossible d'obtenir les fournisseurs d'entrée",
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED:
        "Aucun fournisseur d'entrée n'a été spécifié",
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE:
        "Le fournisseur d'entrée n'est pas disponible",
    'SUPPORTED_DOCUMENT_Account Statement': 'Relevé de compte',
    'SUPPORTED_DOCUMENT_Agreement (Tenancy)': 'Accord (Location)',
    'SUPPORTED_DOCUMENT_Bank Document': 'Document bancaire',
    'SUPPORTED_DOCUMENT_Bank Letter': 'Lettre de la banque',
    'SUPPORTED_DOCUMENT_Bank Statement': 'Relevé bancaire',
    'SUPPORTED_DOCUMENT_Benefit Letter': "Lettre d'avantages",
    'SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)':
        'Certificat (Naissance, Mariage, Partenariat civil)',
    'SUPPORTED_DOCUMENT_Council Document': 'Document du Conseil',
    'SUPPORTED_DOCUMENT_Council Letter': 'Lettre du Conseil',
    'SUPPORTED_DOCUMENT_Council Tax': "Taxe d'habitation",
    'SUPPORTED_DOCUMENT_Driving License': 'Permis de conduire',
    'SUPPORTED_DOCUMENT_Driving Licence': 'Permis de conduire',
    'SUPPORTED_DOCUMENT_DWP Document': 'Document DWP',
    'SUPPORTED_DOCUMENT_HMRC Document': "Document de l'HMRC",
    'SUPPORTED_DOCUMENT_Information Sheet': "Feuille d'information",
    'SUPPORTED_DOCUMENT_Insurance Document': "Document d'assurance",
    'SUPPORTED_DOCUMENT_Insurance Letter': "Lettre d'assurance",
    SUPPORTED_DOCUMENT_Invoice: 'Facture',
    'SUPPORTED_DOCUMENT_NIC Letter': 'Lettre NIC',
    'SUPPORTED_DOCUMENT_NINO Letter': 'Lettre NINO',
    'SUPPORTED_DOCUMENT_Official Document': 'Document officiel',
    'SUPPORTED_DOCUMENT_Official Letter': 'Lettre officielle',
    'SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)':
        "Lettre de remboursement (liée à l'impôt ou au soutien social)",
    'SUPPORTED_DOCUMENT_Tax Letter': 'Lettre fiscale',
    'SUPPORTED_DOCUMENT_Tax Statement': 'Déclaration fiscale',
    'SUPPORTED_DOCUMENT_Tel Bill': 'Tel Bill',
    'SUPPORTED_DOCUMENT_Tel Letter': 'Tel lettre',
    'SUPPORTED_DOCUMENT_Telecommunication Document':
        'Document de télécommunication',
    'SUPPORTED_DOCUMENT_TV Licence': 'redevance télévisuelle',
    'SUPPORTED_DOCUMENT_University Letter': 'Lettre universitaire',
    'SUPPORTED_DOCUMENT_Utility Bill': "Facture d'électricité",
    'SUPPORTED_DOCUMENT_Utility Document': "Document d'utilité",
    'SUPPORTED_DOCUMENT_Utility Letter': "Lettre d'utilité",
    'SUPPORTED_DOCUMENT_Water Bil': 'Eau Bil',
    'SUPPORTED_DOCUMENT_Water Document': "Document d'eau",
    'SUPPORTED_DOCUMENT_Agents License': "Licence d'agent",
    'SUPPORTED_DOCUMENT_Electoral Card': 'Carte électorale',
    'SUPPORTED_DOCUMENT_Foreigner Identification Card':
        "Carte d'identification étrangère",
    'SUPPORTED_DOCUMENT_Health Card': 'Carte de santé',
    'SUPPORTED_DOCUMENT_Job License': "Licence d'emploi",
    'SUPPORTED_DOCUMENT_Membership Identification Card':
        "Carte d'identification de membre",
    'SUPPORTED_DOCUMENT_Military Identification Card':
        "Carte d'identification militaire",
    'SUPPORTED_DOCUMENT_National Identification Card':
        "Carte nationale d'identité",
    SUPPORTED_DOCUMENT_Passport: 'Passeport',
    'SUPPORTED_DOCUMENT_Travel Permit': 'Permis de voyage',
    SUPPORTED_DOCUMENT_Visa: 'Visa',
    'SUPPORTED_DOCUMENT_Weapons Licence': "Licence d'armes",
    'SUPPORTED_DOCUMENT_Selfie Photo': 'Photo de selfie',
    SUPPORTED_DOCUMENT_Unknown: 'Inconnu',
    SUPPORTED_DOCUMENT_COVIDPAS: 'Passe Covid',
    EXTRACTED_FIELDS_AddressFull: 'Adresse complète',
    EXTRACTED_FIELDS_AddressCity: 'Adresse Ville',
    EXTRACTED_FIELDS_AddressPostCode: "Code postal de l'adresse",
    EXTRACTED_FIELDS_LastNameFirstPart: 'Nom de famille Première Partie',
    EXTRACTED_FIELDS_Sex: 'sexe',
    EXTRACTED_FIELDS_BirthPlace: 'Lieu de naissance',
    EXTRACTED_FIELDS_IssueNumber: 'Numéro de problème',
    EXTRACTED_FIELDS_DocumentNumberCheckDigit:
        'Chiffre de contrôle du numéro de document',
    EXTRACTED_FIELDS_BirthDate: 'Date de naissance',
    EXTRACTED_FIELDS_DocumentNumber: 'Numéro de document',
    EXTRACTED_FIELDS_FirstName: 'Prénom',
    EXTRACTED_FIELDS_ArbitraryDigit: 'Chiffre arbitraire',
    EXTRACTED_FIELDS_FirstNameInitial: 'Initiale du prénom',
    EXTRACTED_FIELDS_ExpiryDate: "Date d'expiration",
    EXTRACTED_FIELDS_IssueDate: "Date d'émission",
    EXTRACTED_FIELDS_LastName: 'Nom de famille',
    EXTRACTED_FIELDS_LicenseCategory: 'Catégorie de licence',
    EXTRACTED_FIELDS_DocumentCategory: 'Catégorie de document',
    EXTRACTED_FIELDS_DocumentType: 'Type de document',
    EXTRACTED_FIELDS_NationalityCode: 'Code de nationalité',
    EXTRACTED_FIELDS_MiddleName: 'Deuxième prénom',
    EXTRACTED_FIELDS_FirstIssuanceDate: 'Date de première émission',
    EXTRACTED_FIELDS_SecondLastName: 'Deuxième Nom de Famille',
    EXTRACTED_FIELDS_FullName: 'Nom complet',
    EXTRACTED_FIELDS_PersonalNumber: 'Numéro personnel',
    EXTRACTED_FIELDS_NationalityName: 'Nationalité',
    EXTRACTED_FIELDS_BarcodeItems: 'Code-barres',
    EXTRACTED_FIELDS_BirthPlaceCity: 'Ville de naissance',
    EXTRACTED_FIELDS_BirthPlaceState: 'État de naissance',
    EXTRACTED_FIELDS_BirthPlaceCountry: 'Pays de naissance',
    EXTRACTED_FIELDS_MRZFull: 'Pleine MRZ',
    EXTRACTED_FIELDS_MRZLine1: 'Ligne MRZ 1',
    EXTRACTED_FIELDS_MRZLine2: 'Ligne MRZ 2',
    EXTRACTED_FIELDS_MRZLine3: 'Ligne MRZ 3',
    EXTRACTED_FIELDS_ObservationPage: "Page d'observation",
    EXTRACTED_FIELDS_IssuingAuthority: 'Autorité émettrice',
    EXTRACTED_FIELDS_IssuingLocation: "Lieu d'émission",
    EXTRACTED_FIELDS_MaritalStatus: 'État civil',
    EXTRACTED_FIELDS_Occupation: 'Occupation',
    EXTRACTED_FIELDS_AlienNumber: 'Numéro extraterrestre',
    EXTRACTED_FIELDS_Employer: 'Employeur',
    EXTRACTED_FIELDS_AddressLine1: 'Adresse Ligne 1',
    EXTRACTED_FIELDS_AddressLine2: "Ligne d'adresse 2",
    EXTRACTED_FIELDS_AddressLine3: "Ligne d'adresse 3",
    EXTRACTED_FIELDS_AddressLine4: "Ligne d'adresse 4",
    EXTRACTED_FIELDS_AddressState: 'État',
    EXTRACTED_FIELDS_AddressDistrict: 'Arrondissement',
    EXTRACTED_FIELDS_AddressBuildingNumber: 'Numéro de bâtiment',
    EXTRACTED_FIELDS_AddressBuildingName: 'Nom du bâtiment',
    EXTRACTED_FIELDS_AddressStreet: 'Rue',
    EXTRACTED_FIELDS_AddressCountry: 'Pays',
    EXTRACTED_FIELDS_RefAddressFull: 'Adresse de référence',
    EXTRACTED_FIELDS_RefAddressLine1: "Ligne d'adresse de référence 1",
    EXTRACTED_FIELDS_RefAddressLine2: "Ligne d'adresse de référence 2",
    EXTRACTED_FIELDS_RefAddressLine3: "Ligne d'adresse de référence 3",
    EXTRACTED_FIELDS_RefAddressLine4: "Ligne d'adresse de référence 4",
    EXTRACTED_FIELDS_RefAddressCity: 'Adresse de référence Ville',
    EXTRACTED_FIELDS_RefAddressState: 'Adresse de référence État',
    EXTRACTED_FIELDS_RefAddressDistrict: 'Adresse de référence District',
    EXTRACTED_FIELDS_RefAddressBuildingNumber:
        "Numéro de bâtiment de l'adresse de référence",
    EXTRACTED_FIELDS_RefAddressBuildingName:
        'Adresse de référence Nom du bâtiment',
    EXTRACTED_FIELDS_RefAddressSubBuildingName:
        "Nom du bâtiment de sous-adresse d'adresse de référence",
    EXTRACTED_FIELDS_RefAddressStreet: "Rue de l'adresse de référence",
    EXTRACTED_FIELDS_RefAddressCountry: 'Adresse de référence Pays',
    EXTRACTED_FIELDS_RefAddressPostCode: 'Adresse de référence Code postal',
    EXTRACTED_FIELDS_HealthNumber: 'Numéro de santé',
    EXTRACTED_FIELDS_Endorsements: 'Approbations',
    EXTRACTED_FIELDS_Constraints: 'Contraintes',
    EXTRACTED_FIELDS_LicenseMarine: 'Licence maritime',
    EXTRACTED_FIELDS_Height: 'Hauteur',
    EXTRACTED_FIELDS_Weight: 'Poids',
    EXTRACTED_FIELDS_HairColor: 'Couleur de cheveux',
    EXTRACTED_FIELDS_EyeColor: 'Couleur des yeux',
    EXTRACTED_FIELDS_LensData: 'Vue',
    EXTRACTED_FIELDS_SocialSecurityNumber: 'Numéro de sécurité sociale',
    EXTRACTED_FIELDS_NationalInsuranceNumber: "Numéro d'assurance nationale",
    EXTRACTED_FIELDS_Race: 'Course',
    EXTRACTED_FIELDS_MotherName: 'Nom de la mère',
    EXTRACTED_FIELDS_FatherName: 'Nom du père',
    EXTRACTED_FIELDS_Parents: 'Parents',
    EXTRACTED_FIELDS_Remarks: 'Remarques',
    EXTRACTED_FIELDS_DistinguishingMarks: 'Marques distinctives',
    EXTRACTED_FIELDS_PeriodOfStay: 'Période de séjour',
    EXTRACTED_FIELDS_TaxNumber: "Numéro d'impôt",
    EXTRACTED_FIELDS_Donor: 'Donneur',
    EXTRACTED_FIELDS_RFIDG1: 'Données brutes RFID Groupe 1',
    EXTRACTED_FIELDS_RFIDG2: 'Données brutes RFID Groupe 2',
    EXTRACTED_FIELDS_RFIDG3: 'Données brutes RFID Groupe 3',
    EXTRACTED_FIELDS_RFIDG15: 'Données brutes RFID Groupe 4',
    EXTRACTED_FIELDS_RFIDSOD: 'Données brutes RFID Groupe 5',
    EXTRACTED_FIELDS_PortraitPhoto: 'Photo de portrait extraite',
    EXTRACTED_FIELDS_Title: 'Titre',
    EXTRACTED_FIELDS_IssueDate2: "Deuxième date d'émission",
    EXTRACTED_FIELDS_ExpiryDate2: "Deuxième date d'expiration",
    EXTRACTED_FIELDS_LicenseCategory2: 'Deuxième catégorie de licence',
    EXTRACTED_FIELDS_IssueDate3: "Troisième date d'émission",
    EXTRACTED_FIELDS_ExpiryDate3: "Troisième date d'expiration",
    EXTRACTED_FIELDS_LicenseCategory3: 'Troisième catégorie de licence',
    EXTRACTED_FIELDS_IssueDate4: "Quatrième date d'émission",
    EXTRACTED_FIELDS_ExpiryDate4: "Quatrième date d'expiration",
    EXTRACTED_FIELDS_LicenseCategory4: 'Quatrième catégorie de licence',
    EXTRACTED_FIELDS_MRZCode1: 'Code MRZ 1',
    EXTRACTED_FIELDS_MRZCode2: 'Code MRZ 2',
    EXTRACTED_FIELDS_MRZStandardType: 'Type standard MRZ',
    EXTRACTED_FIELDS_AddressStreetSuffix: 'Suffixe de rue',
    EXTRACTED_FIELDS_AddressStreetType: 'Type de rue',
    EXTRACTED_FIELDS_AddressUnitNumber: "Numéro de l'unité d'adresse",
    EXTRACTED_FIELDS_LicenseNumber: 'Numéro de licence',
    EXTRACTED_FIELDS_AddressStateCode: "Code de l'État",
    EXTRACTED_FIELDS_AddressStreetTypeAbbreviation: 'Abréviation de rue',
    EXTRACTED_FIELDS_AddressUnitType: "Type d'unité d'adresse",
    EXTRACTED_FIELDS_AddressDeliveryPointIdentifier:
        'Identifiant de point de livraison',
    EXTRACTED_FIELDS_AgeCategory: "Catégorie d'âge",
    EXTRACTED_FIELDS_ChildernCount: "Nombre d'enfants",
    EXTRACTED_FIELDS_EntryMode: "Mode d'entrée",
    EXTRACTED_FIELDS_VAFNumber: 'Numéro VAF',
    EXTRACTED_FIELDS_AddressLine5: "Ligne d'adresse 5",
    EXTRACTED_FIELDS_RFIDPortraitPhoto: 'Photo de portrait RFID',
    EXTRACTED_FIELDS_RefAddressLine5: "Ligne d'adresse de référence 5",
    EXTRACTED_FIELDS_RefAddressStateCode: 'Adresse de référence État',
    EXTRACTED_FIELDS_RefAddressStreetType:
        "Type de rue de l'adresse de référence",
    EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation:
        "Type d'abréviation de rue d'adresse de référence",
    EXTRACTED_FIELDS_RefAddressStreetSuffix:
        "Suffixe de rue de l'adresse de référence",
    EXTRACTED_FIELDS_RefAddressUnitNumber:
        "Numéro d'unité d'adresse de référence",
    EXTRACTED_FIELDS_RefAddressUnitType: "Unité d'adresse de référence",
    EXTRACTED_FIELDS_RefAddressPostcodeType:
        'Adresse de référence Code postal Type',
    EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier:
        "Identifiant de point de livraison d'adresse de référence",
    EXTRACTED_FIELDS_RefAddressPOBoxNumber:
        'Adresse de référence Numéro de boîte postale',
    EXTRACTED_FIELDS_RefAddressDependentLocality:
        "Localité dépendante de l'adresse de référence",
    EXTRACTED_FIELDS_RefAddressDoubleDependentLocality:
        'Adresse de référence Double Localité Dépendante',
    EXTRACTED_FIELDS_RefAddressThoroughfare: 'Adresse de référence Voie',
    EXTRACTED_FIELDS_RefAddressThoroughfareDesc:
        "Description de la voie de l'adresse de référence",
    EXTRACTED_FIELDS_RefAddressDependentThoroughfare:
        "Voie Dépendante de l'Adresse de Référence",
    EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc:
        "Description de la voie dépendante de l'adresse de référence",
    EXTRACTED_FIELDS_RefAddressSubBuildingNumber:
        'Adresse de référence Sous-bâtiment Numéro',
    EXTRACTED_FIELDS_AddressSubBuildingNumber: 'Numéro de bâtiment auxiliaire',
    EXTRACTED_FIELDS_AddressSubBuildingName: 'Nom du bâtiment auxiliaire',
    EXTRACTED_FIELDS_AddressPostCodeType: 'Type de code postal',
    EXTRACTED_FIELDS_IssuingAuthorityType: "Type d'autorité émettrice",
    EXTRACTED_FIELDS_Signature: 'Signature',
    EXTRACTED_FIELDS_Hologram: 'Hologram',
    EXTRACTED_FIELDS_CardNumber: 'Numéro de carte',
    EXTRACTED_FIELDS_MiddleNameInitial: 'Initiale du deuxième prénom',
    EXTRACTED_FIELDS_PermitNumber: 'Numéro de permis',
    EXTRACTED_FIELDS_ReferenceNumber: 'Numéro de référence',
    EXTRACTED_FIELDS_CustomerNumber: 'Numéro de client',
    EXTRACTED_FIELDS_BOSNumber: 'Numéro BOS',
    EXTRACTED_FIELDS_StudentID: "Numéro d'identification de l'étudiant",
    EXTRACTED_FIELDS_MembershipNumber: "Numéro d'adhésion",
    EXTRACTED_FIELDS_LicenseType: 'Type de licence',
    EXTRACTED_FIELDS_LicenseType2: 'Type de licence 2',
    EXTRACTED_FIELDS_LicenseType3: 'Type de licence 3',
    EXTRACTED_FIELDS_LicenseType4: 'Type de licence 4',
    EXTRACTED_FIELDS_DocumentTypeCode: 'Code de type de document',
    EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit: 'Chiffre de contrôle MRZ',
    EXTRACTED_FIELDS_MRZBirthDateCheckDigit:
        'Chiffre de contrôle de la date de naissance MRZ',
    EXTRACTED_FIELDS_MRZExpiryDateCheckDigit:
        "Chiffre de contrôle de la date d'expiration MRZ",
    EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit:
        'Chiffre de contrôle du numéro personnel MRZ',
    EXTRACTED_FIELDS_MRZCompositeCheckDigit:
        'Chiffre de contrôle composite MRZ',
    EXTRACTED_FIELDS_SecondaryPortraitPhoto: 'Photo de portrait secondaire',
    EXTRACTED_FIELDS_Fingerprint: 'Empreinte digitale',
    EXTRACTED_FIELDS_VersionNumber: 'Numéro de version',
    EXTRACTED_FIELDS_Conditions: 'Conditions',
    EXTRACTED_FIELDS_NickName: 'Surnom',
    EXTRACTED_FIELDS_AddressApartmentNumber: "Numéro d'appartement",
    EXTRACTED_FIELDS_AddressFloorNumber: "Numéro d'étage",
    EXTRACTED_FIELDS_FirstNameLocal: 'Prénom Local',
    EXTRACTED_FIELDS_LastNameLocal: 'Nom de famille Local',
    EXTRACTED_FIELDS_FullNameLocal: 'Nom complet local',
    EXTRACTED_FIELDS_BirthPlaceLocal: 'Lieu de naissance local',
    EXTRACTED_FIELDS_IssuingAuthorityLocal: 'Autorité émettrice locale',
    EXTRACTED_FIELDS_MotherNameLocal: 'Nom de la mère locale',
    EXTRACTED_FIELDS_FatherNameLocal: 'Nom du père Local',
    EXTRACTED_FIELDS_AddressFullLocal: 'Adresse complète locale',
    EXTRACTED_FIELDS_MiddleNameLocal: 'Deuxième prénom Local',
    EXTRACTED_FIELDS_AddressLine1Local: 'Adresse Ligne1 Local',
    EXTRACTED_FIELDS_AddressLine2Local: "Ligne d'adresse 2 Locale",
    EXTRACTED_FIELDS_AddressLine3Local: 'Adresse Ligne3 Local',
    EXTRACTED_FIELDS_IndRefNumber1: 'Numéro de référence individuel 1',
    EXTRACTED_FIELDS_IndRefNumber2: 'Numéro de référence individuel 2',
    EXTRACTED_FIELDS_IndRefNumber3: 'Numéro de référence individuel 3',
    EXTRACTED_FIELDS_IndRefNumber4: 'Numéro de référence individuel 4',
    EXTRACTED_FIELDS_IndRefNumber5: 'Numéro de référence individuel 5',
    EXTRACTED_FIELDS_Name1: 'Nom 1',
    EXTRACTED_FIELDS_Name2: 'Nom 2',
    EXTRACTED_FIELDS_Name3: 'Nom 3',
    EXTRACTED_FIELDS_Name4: 'Nom 4',
    EXTRACTED_FIELDS_Name5: 'Nom 5',
    EXTRACTED_FIELDS_RECIPIENT_NAME_1: 'Nom du bénéficiaire 1',
    EXTRACTED_FIELDS_RECIPIENT_NAME_2: 'Nom du bénéficiaire 2',
    EXTRACTED_FIELDS_RECIPIENT_NAME_3: 'Nom du bénéficiaire 3',
    EXTRACTED_FIELDS_RECIPIENT_NAME_4: 'Nom du bénéficiaire 4',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL: 'Adresse du destinataire Complète',
    EXTRACTED_FIELDS_IBAN: 'IBAN Numéro de compte',
    EXTRACTED_FIELDS_ACCOUNT_NUM: 'Numéro de compte',
    EXTRACTED_FIELDS_ISSUER: 'Émetteur',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY: 'Adresse du destinataire Ville',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE:
        'Adresse du destinataire Code postal',
    EXTRACTED_FIELDS_DAY: 'Jour',
    EXTRACTED_FIELDS_MONTH: 'Mois',
    EXTRACTED_FIELDS_YEAR: 'Année',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_1: 'Valeur optionnelle 1',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_2: 'Valeur optionnelle 2',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_3: 'Valeur optionnelle 3',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_4: 'Valeur optionnelle 4',
    EXTRACTED_FIELDS_ISSUING_STATE_NAME: "Nom de l'État émetteur",
    EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID: 'Type de document recto Id',
    EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID: 'Id du type de document au verso',
    HASNOCAMERA_TITLE:
        "Oups, nous n'avons pas pu reconnaître de caméra sur votre appareil !",
    HASNOCAMERA_DESCRIPTION:
        "Il semble que votre appareil ne soit pas équipé d'une caméra. Veuillez réessayer sur un autre appareil équipé d'une caméra en état de marche afin de pouvoir effectuer toutes les étapes requises.",
    EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT: 'Covid Type Id',
    USER_INPUT_FIRST_NAME: 'Prénom',
    USER_INPUT_MIDDLE_NAME: 'Deuxième prénom',
    USER_INPUT_LAST_NAME: 'Nom de famille',
    USER_INPUT_DOB: 'Date de naissance',
    USER_INPUT_HOUSE_NAME_NUMBER: 'Nom/Numéro de la maison*',
    USER_INPUT_STREET_NAME: 'Nom de la rue*',
    USER_INPUT_TOWN: 'Ville*',
    USER_INPUT_POSTAL_CODE: 'Code postal*',
    USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE: 'ex. Maison/35',
    USER_INPUT_STREET_NAME_EXAMPLE: "ex. Rue de l'Essai",
    USER_INPUT_TOWN_EXAMPLE: 'ex. Quelque part',
    USER_INPUT_POSTAL_CODE_EXAMPLE: 'ex. CH496 (sans espace)',
    SYSTEM_NOT_ABLE: "Le système n'a pas pu scanner le document",
    TRY_AGAIN: 'Réessayer',
    HINTS_DISABLED_HEADER: 'Les indices sont désactivés en mode manuel',
    HINTS_DISABLED_DESCRIPTION:
        'Si vous voulez activer les indices pour prendre une photo, passez en mode CAPTURE AUTOMATIQUE',
    YOU_HAVE: 'Vous avez',
    PICTURE_VERIFYING: 'Vérification...',
    HOW_TO_TAKE_PHOTO_CORRECTLY: 'Comment prendre une photo correctement',
};
